var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterActiveMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8789062,2H8.1210938C6.4003906,2,5,3.4003906,5,5.1210938C5,5.9433594,5.3330078,6.7470703,5.9140625,7.328125 l12.6210938,12.6210938C19.4794922,20.8935547,20,22.1494141,20,23.4853516V39c0,0.265625,0.1054688,0.5195312,0.2929688,0.7070312 l6,6C26.484375,45.8984375,26.7402344,46,27,46c0.1289062,0,0.2587891-0.0244141,0.3828125-0.0761719 C27.7568359,45.7695312,28,45.4042969,28,45V23.4853516c0-1.3359375,0.5205078-2.5917969,1.4648438-3.5361328L42.0859375,7.328125 C42.6669922,6.7470703,43,5.9433594,43,5.1210938C43,3.4003906,41.5996094,2,39.8789062,2z M40.671875,5.9140625 L28.0507812,18.5351562C26.7285156,19.8574219,26,21.6152344,26,23.4853516v19.1005859l-4-4V23.4853516 c0-1.8701172-0.7285156-3.6279297-2.0507812-4.9501953L7.328125,5.9140625C7.1191406,5.7050781,7,5.4160156,7,5.1210938 C7,4.5029297,7.5029297,4,8.1210938,4h31.7578125C40.4970703,4,41,4.5029297,41,5.1210938 C41,5.4160156,40.8808594,5.7050781,40.671875,5.9140625z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterActiveMedium);
export default __webpack_public_path__ + "static/media/filter-active--medium.6f4e2c8e0014b8487d9951ef65d6a25d.svg";
export { ForwardRef as ReactComponent };